import * as React from 'react';
import { getColorValue } from '../utilities/color';

function Compliance(props) {
  const orange = getColorValue('illustrationOrange');
  const green = getColorValue('illustrationGreen');
  const gray = getColorValue('illustrationLine');

  return (
    <svg fill="none" height="275" viewBox="0 0 275 275" width="275" {...props}>
      <path
        d="m197.355 66.979v69.54c0 42.7-12.75 69.24-34.24 83.41-13.66 9-30.85 13.02-50.54 13.02-19.6905 0-36.4205-3.44-50.0705-11.12-24.25-13.64-37.97-40.62-36.38-85.31v-69.27c7.1 1.6 14.74 2.48 22.74 2.48 28.44 0 52.7205-11.11 62.3305-26.73 9.62 15.62 33.88 26.73 62.32 26.73 8.41 0 16.45-.96 23.85-2.74h-.01z"
        fill={orange}
      />
      <path
        d="m147.764 147.008 73.33-76.3996 27.13 25.12-106.53 91.4496-50.1496-46.22 26.0796-30.1z"
        fill={green}
      />
      <path
        d="m197.454 95.2383v44.0597l-55.76 47.87-50.1496-46.22 26.0796-30.1 30.14 36.17z"
        fill={getColorValue('tealDark')}
      />
      <path
        d="m105.755 211.972c2.94.05 4.41-.3 4.41-.59 0-.33-1.46-.59-4.36-.76-4.11-.23-8.3105-.68-12.7905-1.52-4.47-.86-9.25-2.11-14.3-4.3-2.86-1.23-5.09-2.44-6.93-3.59-.46-.28-.92-.53-1.34-.81-.41-.29-.81-.57-1.19-.84-.75-.56-1.52-1.01-2.15-1.57-1.3-1.08-2.55-2.05-3.7-3.27-.58-.61-1.25-1.16-1.81-1.89-.59-.71-1.21-1.45-1.89-2.26-2.15-2.85-4.36-6.44-6.14-10.44-1.72-4.03-3.03-8.4-3.96-12.59-.83-4.21-1.37-8.21-1.6-11.53-.1-1.66-.23-3.14-.26-4.39-.02-1.25-.04-2.27-.05-3 0-.87-.06-1.73-.05-2.6.07-3.1.01-11.53-.03-22.14-.01-5.3-.03-11.15-.04-17.15 0-3 0-6.04 0-9.0597 0-1.51 0-3.02 0-4.53 0-.73 0-1.46 0-2.19 0-.09-.02-.2.1-.14.35.07.69.14 1.02.2.51.09 1.01.18 1.51.27.99.17 1.97.32 2.92.43 1.9.25 3.71.41 5.43.51 3.44.23 6.51.12 9.21 0 1.35-.11 2.61-.17 3.78-.3 1.17-.14 2.25-.28 3.25-.4 1.98-.36 3.65-.6 4.98-.93 3.17-.65 6.06-1.6 8.77-2.56 2.68-1.05 5.18-2.14 7.45-3.46 4.5605-2.55 8.4205-5.6 11.3905-9.36.85-1 1.31-1.89 1.59-2.49s.35-.94.23-1.01-.41.12-.86.59c-.45.46-1.02 1.22-1.88 2.14-3.01 3.48-6.8105 6.27-11.2805 8.65-2.22 1.22-4.67 2.24-7.27 3.23-2.64.9-5.45 1.81-8.54 2.44-2.38.54-6.12 1.17-11.07 1.41-4.94.24-11.13.15-18.19-1.13l-1.72-.33-1.52-.32-.86-.18-.43-.09c-.06 0-.17-.06-.19-.01v.22l.02 3.08.03 1.77c.36 20.3097.26 46.6697.26 46.6697s-.03 2.47-.09 6.43c.1 3.97.19 9.46 1.12 15.41.86 5.95 2.45 12.35 4.84 17.98 2.35 5.65 5.52 10.43 8.29 13.62 4.14 4.86 8.07 7.61 11.09 9.52 3.03 1.94 5.3 2.94 7.01 3.69 5.22 2.26 10.15 3.49 14.74 4.28 4.6.77 8.8805 1.1 13.0505 1.16z"
        fill={gray}
      />
    </svg>
  );
}

export default Compliance;
